export default function AboutSection() {
  return (
    <section id="sobre" className="relative w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          {/* Left - Image */}
          <div className="flex-1 w-full">
            <div className="relative w-full aspect-[4/3] rounded-[40px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Organized%20modern%20desk%20workspace%20with%20open%20laptop%20displaying%20spreadsheet%20data%2C%20surrounded%20by%20fashion%20accessories%20including%20watch%20sunglasses%20and%20small%20leather%20goods%2C%20warm%20ambient%20lighting%20from%20desk%20lamp%2C%20cozy%20creative%20studio%20atmosphere%2C%20beige%20and%20taupe%20color%20palette%2C%20lifestyle%20workspace%20photography%2C%20shallow%20depth%20of%20field%20with%20bokeh%20background&width=800&height=600&seq=about-section-v2&orientation=landscape"
                alt="CSSBuy Spreadsheet - Curadoria de Produtos"
                title="CSSBuy Spreadsheet - Como Funciona"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>

          {/* Right - Content */}
          <div className="flex-1 flex flex-col items-start">
            <span className="inline-block bg-secondary-100 text-secondary-700 text-xs font-semibold px-4 py-1.5 rounded-full mb-4">
              Por que escolher
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight mb-6">
              Economize tempo<br />
              <span className="text-accent-500">e dinheiro</span>
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8 max-w-lg">
              O CSSBuy Spreadsheet foi criado para simplificar sua experiência de compra. Em vez de passar horas procurando vendedores e links, você encontra tudo organizado em uma única planilha, atualizada diariamente com os melhores produtos das categorias mais populares: tênis, roupas, acessórios e muito mais.
            </p>

            <div className="flex flex-col gap-3 mb-8">
              {[
                'Links verificados e atualizados diariamente',
                'Produtos organizados por categoria e marca',
                'Acesso gratuito a todas as planilhas',
                'Comunidade ativa de compradores',
              ].map((item, idx) => (
                <div key={idx} className="flex items-center gap-3">
                  <span className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-100 flex-shrink-0">
                    <i className="ri-check-line text-accent-600 text-xs"></i>
                  </span>
                  <span className="text-foreground-700 text-sm">{item}</span>
                </div>
              ))}
            </div>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="group inline-flex items-center gap-2 bg-primary-500 text-white font-semibold px-8 py-3.5 rounded-full whitespace-nowrap hover:bg-primary-600 transition-colors duration-200 cursor-pointer text-sm"
            >
              Explorar Agora
              <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}